import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    category: '',
    level: '',
    search: ''
  });
  
  const isFirstRender = useRef(true);

  const fetchCategories = useCallback(async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/categories');
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  }, []);

  const fetchCourses = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filters.category) params.append('category', filters.category);
      if (filters.level) params.append('level', filters.level);
      if (filters.search) params.append('search', filters.search);
      
      const response = await axios.get(`http://localhost:5000/api/courses?${params}`);
      setCourses(response.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
    setLoading(false);
  }, [filters]);

  useEffect(() => {
    fetchCategories();
    fetchCourses();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    fetchCourses();
    // eslint-disable-next-line
  }, [filters.category, filters.level, filters.search]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleSearchChange = (e) => {
    setFilters({ ...filters, search: e.target.value });
  };

  const clearFilters = () => {
    setFilters({ category: '', level: '', search: '' });
  };

  const activeFilterCount = () => {
    let count = 0;
    if (filters.category) count++;
    if (filters.level) count++;
    if (filters.search) count++;
    return count;
  };

  if (loading) {
    return (
      <div className="container text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading courses...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>All Courses</h1>
        <span className="badge bg-primary">{courses.length} courses found</span>
      </div>
      
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <input
                type="text"
                className="form-control"
                name="search"
                placeholder="🔍 Search courses..."
                value={filters.search}
                onChange={handleSearchChange}
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                name="category"
                value={filters.category}
                onChange={handleFilterChange}
              >
                <option value="">📂 All Categories</option>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                name="level"
                value={filters.level}
                onChange={handleFilterChange}
              >
                <option value="">📊 All Levels</option>
                <option value="beginner">🌱 Beginner</option>
                <option value="intermediate">📈 Intermediate</option>
                <option value="advanced">🚀 Advanced</option>
              </select>
            </div>
            <div className="col-md-2">
              {activeFilterCount() > 0 && (
                <button className="btn btn-outline-secondary w-100" onClick={clearFilters}>
                  ✕ Clear Filters ({activeFilterCount()})
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {courses.length === 0 ? (
          <div className="col-12 text-center py-5">
            <h4>😕 No courses found</h4>
            <p className="text-muted">Try adjusting your filters</p>
            <button className="btn btn-primary mt-2" onClick={clearFilters}>
              Clear all filters
            </button>
          </div>
        ) : (
          courses.map(course => (
            <div className="col-md-4 mb-4" key={course.id}>
              <div className="card course-card h-100">
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{course.title}</h5>
                  <p className="card-text text-muted small flex-grow-1">
                    {course.short_description || course.description?.substring(0, 100)}
                  </p>
                  <div className="mb-2">
                    <span className="badge bg-primary me-1">{course.category_name}</span>
                    <span className="badge bg-info">{course.level || 'beginner'}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <span className="text-primary fw-bold h5 mb-0">${course.price}</span>
                    <span className="text-muted small">{course.enrolled_students || 0} enrolled</span>
                  </div>
                  <Link to={`/courses/${course.id}`} className="btn btn-primary mt-3 w-100">
                    View Details →
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Courses;